<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title class="redColor d-flex">
        <span class="headline" />
        <v-spacer />
        <v-icon color="white" @click="close()"> mdi-close </v-icon>
      </v-card-title>
      <h4 class="text-center pa-4">
        <div v-if="items && items.brand && items.model">
          {{ $t("parts.inventory.cars_alert") }}
        </div>
        <div v-if="items && items.rr && items.rr !== 'Not found'">
          {{ $t("parts.inventory.rr_message") }}
        </div>
        <div v-if="items && items.rr && items.rr === 'Not found'">
          {{ $t("parts.inventory.rr_not_found_message") }}
        </div>
      </h4>
      <v-card-text>
        <v-row class="align-center justify-center d-flex">
          <v-btn
            v-if="items && items.brand && items.model"
            color="red"
            @click="
              $router.push({
                path: '/vehicle-entry',
                query: {
                  brand: items.brand,
                  model: items.model ? items.model : null,
                },
              })
            "
          >
            {{ $t("parts.inventory.go_to_cars") }}
          </v-btn>
          <!-- Show "Go to RR" button if rr (link) exists -->
          <v-btn
            v-if="items && items.rr && items.rr !== 'Not found'"
            color="#bfbdb6"
            class="ma-2"
            @click="goToRR"
          >
            {{ $t("parts.inventory.go_to_rr") }}
            <img
              height="20"
              width="20"
              class="ml-2"
              src="@/assets/rr-logo.png"
            />
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  data: () => ({
    dialog: false,
    items: null,
  }),
  watch: {},
  methods: {
    open(data) {
      this.items = data;
      this.dialog = true;
    },
    goToRR() {
      if (this.items.rr) {
        // Open rr link in a new tab
        window.open(this.items.rr, "_blank");
      }
      this.close();
    },
    close() {
      this.items = null;
      this.dialog = false;
      // this.$emit('close');
    },
  },
};
</script>
